import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VumatelapplicationhistoryComponent } from './vumatelapplicationhistory.component';

const routes: Routes = [
    {
        path: '',
        component: VumatelapplicationhistoryComponent,
        data: {
            title: 'Vumatel Application History'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class  VumatelapplicationhistoryRoutingModule { }
